import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";

class PeopleAtWorkRecordHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      internalId: props.node.$.internalID,
      formData: props.formData,
    };
  }

  componentWillReceiveProps(nextProps) {
    const internalId = nextProps.node.$.internalID;
    this.setState({
      formData: nextProps.formData,
      internalId,
    });
  }

  render() {
    let nameNode;
    _.forEach(_.get(this.props.node, "name"), (node) => {
      if (!nameNode && _.get(node, "middle[0]._", "") !== "") {
        nameNode = node;
      }
    });
    if (!nameNode) {
      nameNode = _.get(this.props.node, "name[0]");
    }
    const name = `${_.get(nameNode, "first[0]._", "")} ${_.get(
      nameNode,
      "middle[0]._",
      ""
    )} ${_.get(nameNode, "last[0]._", "")}`;
    return (
      <Table>
        <Table.Body>
          <Table.Row className={"result-header"}>
            <Table.Cell className={"icon-align-middle"}>{name}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default PeopleAtWorkRecordHeader;



// WEBPACK FOOTER //
// ./src/components/searchresults/PeopleAtWorkRecordHeader.js